import { logging } from "./logging/logging";

export const environmentService = {
  logging,
};
